<template>
	<div class="drawer-container padded">
		<loading v-if="!loaded"></loading>

		<module-form v-if="loaded" :key="`${ module.id }-${ formData.id }`" :module-data="moduleData" :row="formData" :is-update="isUpdate" :is-drawer="true" @saved="onSaved">
			<template slot="buttons">
				<div class="buttons"><a href @click.prevent="close" class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></a></div>
			</template>
		</module-form>
	</div>
</template>

<script>

import { DRAWERS } from '@/constants';
import ModuleForm from '../components/ModuleFormComponent';

export default {

	name: 'ModuleFormDrawer',

	data() {
		return {
			loaded: false,
			isUpdate: false,
			module: {},
			params: {},
			rowData: {},
			moduleData: {},
		};
	},

	computed: {
		formData() {
			if (typeof this.params.formData !== 'undefined') {
				return this.params.formData;
			}

			return {};
		},
	},

	mounted() {
		this.addRootListener(`${ DRAWERS.MODULE_FORM }.drawer-opened`, async (props = {}) => {
			this.loaded = false;
			this.params = props;

			this.isUpdate = !!props.isUpdate;
			this.module = props.module || {};

			const payload = await this.$api.get(
				this.isUpdate
					? `/module/${ this.module.slug }/${ this.params.id }/edit`
					: `/module/${ this.module.slug }/create/${ this.params.id }`
			);

			this.setData(payload.data);
		});
	},

	methods: {

		setData({ module, tags, associatedModules, ...rowData }) {
			this.rowData = {
				row: {},
				...rowData
			};

			this.params.formData = JSON.parse(JSON.stringify({
				...this.params.formData,
				...this.rowData.row,
			}));

			this.moduleData = {
				module, tags, associatedModules
			};

			this.$nextTick(() => this.loaded = true);
		},

		onSaved(response) {
			this.close();
			this.$root.$emit('modal-form-saved', {
				module: this.module,
				response
			});
		},

		close() {
			this.loaded = false;
			this.$root.$emit('close-drawer', DRAWERS.MODULE_FORM);
		},

	},

	components: {
		ModuleForm,
	},
};

</script>
